// Domini "parent" per gli embed Twitch (player e chat).
// Twitch esige un parametro parent per OGNI dominio nella catena di iframe:
// se il sito è visto dentro un altro iframe (es. anteprima della piattaforma),
// hostname da solo non basta e Twitch nega la connessione.
export function twitchParents() {
  const parents = new Set([window.location.hostname]);
  try {
    if (window.location.ancestorOrigins) {
      for (const origin of window.location.ancestorOrigins) {
        parents.add(new URL(origin).hostname);
      }
    }
  } catch {}
  try {
    if (document.referrer) parents.add(new URL(document.referrer).hostname);
  } catch {}
  return [...parents].filter(Boolean).map((p) => `parent=${p}`).join("&");
}
